export default __webpack_public_path__ + "static/globe-plaza01-d15003ba891fc782cd5ad63492c122b4.jpg";